'use strict';

exports.__esModule = true;
exports.TopNavLinks = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _reactRouter = require('react-router');

var _defaultMessages = require('../lang/default-messages');

var _defaultMessages2 = _interopRequireDefault(_defaultMessages);

var _availableProfilesList = require('./available-profiles-list');

var _settingsDropdown = require('./settings-dropdown');

var _doctifyUtils = require('doctify-utils');

var _style = require('../../src/styles/style.scss');

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TopNavLinks = function TopNavLinks(props) {
	var loggedIn = props.loggedIn,
	    pageName = props.pageName,
	    currentProfile = props.currentProfile,
	    availableProfiles = props.availableProfiles,
	    profileDropdownOpen = props.profileDropdownOpen,
	    settingsDropdownOpen = props.settingsDropdownOpen,
	    openReviewModal = props.openReviewModal,
	    closeModal = props.closeModal,
	    logOut = props.logOut,
	    openSignUpModal = props.openSignUpModal,
	    toggleProfileDropdown = props.toggleProfileDropdown,
	    toggleSettingsDropdown = props.toggleSettingsDropdown,
	    searchJournal = props.searchJournal,
	    openProfileWizard = props.openProfileWizard,
	    intl = props.intl,
	    onProfileClicked = props.onProfileClicked;

	var blogLinks = pageName === 'blog' ? [_react2.default.createElement(
		'li',
		null,
		_react2.default.createElement(
			'a',
			{ to: '/blog', onClick: searchJournal },
			intl.formatMessage(_defaultMessages2.default.SEARCH_JOURNAL)
		)
	), _react2.default.createElement(
		'li',
		null,
		_react2.default.createElement(
			'a',
			{ to: '/blog/articles' },
			intl.formatMessage(_defaultMessages2.default.ARTICLES)
		)
	), _react2.default.createElement(
		'li',
		null,
		_react2.default.createElement(
			'a',
			{ to: '/blog/categories' },
			intl.formatMessage(_defaultMessages2.default.CATEGORIES)
		)
	)] : null;

	var loggedInDropdowns = loggedIn ? [
	// profiles dropdown
	_react2.default.createElement(_availableProfilesList.AvailableProfilesList, {
		profiles: availableProfiles,
		currentProfile: currentProfile,
		isOpen: profileDropdownOpen,
		onProfileClicked: onProfileClicked,
		toggleProfileDropdown: toggleProfileDropdown }),
	//settings dropdown
	_react2.default.createElement(
		'li',
		null,
		_react2.default.createElement(
			'a',
			{ onClick: toggleSettingsDropdown },
			_react2.default.createElement('i', { className: 'ion-gear-b' })
		),
		_react2.default.createElement(_settingsDropdown.SettingsDropdown, {
			currentProfile: currentProfile,
			isOpen: settingsDropdownOpen,
			logOut: function (_logOut) {
				function logOut() {
					return _logOut.apply(this, arguments);
				}

				logOut.toString = function () {
					return _logOut.toString();
				};

				return logOut;
			}(function () {
				closeModal();
				logOut();
			}),
			showProfileWizard: openProfileWizard })
	)] : null;

	return _react2.default.createElement(
		'ul',
		{ className: _style2.default.menuList + ' list-inline hidden-xs' },
		_react2.default.createElement(
			'li',
			null,
			_react2.default.createElement(
				'a',
				{ href: 'https://vitality.co.uk/member/login', target: '_blank', rel: 'noreferrer noopener',
					alt: intl.formatMessage(_defaultMessages2.default.VITALITY_MEMBERZONE) },
				intl.formatMessage(_defaultMessages2.default.VITALITY_MEMBERZONE)
			)
		),
		_react2.default.createElement(
			'li',
			null,
			_react2.default.createElement(
				_reactRouter.Link,
				{ className: _style2.default.linkBtn + ' btn', to: '/',
					alt: intl.formatMessage(_defaultMessages2.default.SPECIALIST_FINDER) },
				intl.formatMessage(_defaultMessages2.default.SPECIALIST_FINDER)
			)
		)
	);
};

TopNavLinks.propTypes = {
	loggedIn: require('react').PropTypes.bool.isRequired,
	pageName: require('react').PropTypes.string.isRequired,
	currentProfile: require('react').PropTypes.any,
	availableProfiles: require('react').PropTypes.arrayOf(require('react').PropTypes.any),
	profileDropdownOpen: require('react').PropTypes.bool.isRequired,
	settingsDropdownOpen: require('react').PropTypes.bool.isRequired,
	mobileMenuOpen: require('react').PropTypes.bool.isRequired,
	showAvailableProfiles: require('react').PropTypes.bool.isRequired,
	openReviewModal: require('react').PropTypes.func.isRequired,
	logOut: require('react').PropTypes.func.isRequired,
	openSignUpModal: require('react').PropTypes.func.isRequired,
	toggleProfileDropdown: require('react').PropTypes.func.isRequired,
	toggleSettingsDropdown: require('react').PropTypes.func.isRequired,
	toggleMobileProfiles: require('react').PropTypes.func.isRequired,
	searchJournal: require('react').PropTypes.func.isRequired,
	openProfileWizard: require('react').PropTypes.func.isRequired,
	toggleMobileMenu: require('react').PropTypes.func.isRequired
};

var hoc = (0, _reactIntl.injectIntl)(TopNavLinks);
exports.TopNavLinks = hoc;


// WEBPACK FOOTER //
// ./components/top-nav/lib/components/top-nav-links.js